import { QuoteServiceVariable } from '../quoteservicecomputation';
import { IQuoteServiceVariableData } from '../quoteservicecomputation.types';

export const mockQuoteServiceVariablesData = (): IQuoteServiceVariableData[] => [];

export const mockQuoteServiceVariables = () =>
  mockQuoteServiceVariablesData().map(
    variable => new QuoteServiceVariable(variable)
  );
